import get from 'lodash/get';

import { countries } from '../../constants';

export default function marketsWithShare(countrySplit) {
  const markets = [];
  countries.forEach(({ countryCode }) => {
    const share = get(countrySplit, countryCode, 0);
    if (share !== 0) {
      markets.push(countryCode);
    }
  });
  return markets || [];
}
